// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ToastProvider from './components/Toast';
import OfflineToast from './components/OfflineToast';
import Login from './components/Login';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import BuyCredits from "./components/BuyCredits";
import Checkout from "./components/Checkout";
import Homepage from "./components/Homepage";
import Landing from "./components/Landing";
import TimerPage from "./components/TimerPage";
import GuestRuns from "./components/GuestRuns";
import GuestRacers from "./components/GuestRacers";
import GuestGroups from "./components/GuestGroups";
import GuestTracks from "./components/GuestTracks";
import TracksList from "./components/TracksList";
import { useAuth } from './contexts/AuthContext';
import AdminPage from "./components/AdminPage";
import RunsList from "./components/RunsList";
import RacersList from "./components/RacersList";
import GroupsList from "./components/GroupsList";
import CompareRacers from "./components/CompareRacers";
import RacerView from "./components/RacerView";
import SharedView from "./components/SharedView";
import PublicRunView from "./components/PublicRunView";
import SharingGroupsList from "./components/SharingGroupsList";
import SharedGroupView from "./components/SharedGroupView";

function RootRedirect() {
  const { user } = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  
  // Check for sharing tokens
  const shareToken = searchParams.get('token');
  const shareGroupToken = searchParams.get('shareGroupToken');
  
  // If there's a share token, redirect to shared view
  if (shareToken) {
    return <Navigate to={`/shared/${shareToken}`} replace />;
  }
  
  // If there's a share group token, redirect to shared group view
  if (shareGroupToken) {
    return <Navigate to={`/shared-group/${shareGroupToken}`} replace />;
  }
  
  // Default behavior: logged in users go to homepage, guests go to landing
  return user ? <Navigate to="/homepage" /> : <Navigate to="/landing" />;
}

function InnerApp() {
  const location = useLocation();
  return (
    <div className="app-container">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <div className="main-content">
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/tos" element={<TermsOfService />} />
          <Route path="/buy-credits" element={<BuyCredits />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/runs-list" element={<RunsList />} />
          <Route path="/tracks" element={<TracksList />} />
          <Route path="/racers-list" element={<RacersList />} />
          <Route path="/groups" element={<GroupsList />} />
          <Route path="/racer/:racerId" element={<RacerView />} />
          <Route path="/compare/:racerIds" element={<CompareRacers />} />
             
          <Route path="/timer" element={<TimerPage key={location.key} />} />
          <Route path="/runs" element={<RunsList />} />
          <Route path="/guest-racers" element={<GuestRacers />} />
          <Route path="/guest-groups" element={<GuestGroups />} />
          <Route path="/guest-tracks" element={<GuestTracks />} />
          <Route path="/shared/:token" element={<SharedView />} />
          <Route path="/shared/run/:runId" element={<SharedView />} />
          <Route path="/public/run/:runId" element={<PublicRunView />} />
          <Route path="/sharing-groups" element={<SharingGroupsList />} />
          <Route path="/shared-group/:token" element={<SharedGroupView />} />
          <Route path="*" element={<Navigate to="/landing" replace />} />
        </Routes>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <OfflineToast />
        <BrowserRouter>
          <InnerApp />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;